import { render, staticRenderFns } from "./StorageLocationImporter.vue?vue&type=template&id=5bd35247"
import script from "./StorageLocationImporter.vue?vue&type=script&lang=js"
export * from "./StorageLocationImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports